/**
 * Kbd — inline keycap hint (⌘K, Esc, g …) styled with design-system tokens.
 *
 * Used for keyboard-shortcut affordances: the header search badge, the
 * command palette footer legend, and the shortcuts help overlay.
 */
import React from 'react';
import { theme } from '../../theme';

export interface KbdProps {
  children: React.ReactNode;
  /** Style overrides merged over the keycap base (e.g. cursor, min-width). */
  style?: React.CSSProperties;
  onClick?: () => void;
  title?: string;
}

export const kbdBaseStyle: React.CSSProperties = {
  display: 'inline-block',
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
  fontSize: '0.625rem',
  fontWeight: 600,
  color: theme.colors.text.secondary,
  backgroundColor: theme.colors.background.tertiary,
  border: `1px solid ${theme.colors.border.light}`,
  borderRadius: '0.25rem',
  padding: '0.125rem 0.3125rem',
  whiteSpace: 'nowrap',
};

export const Kbd: React.FC<KbdProps> = ({ children, style, onClick, title }) => (
  <span onClick={onClick} title={title} style={{ ...kbdBaseStyle, ...(onClick ? { cursor: 'pointer' } : {}), ...style }}>
    {children}
  </span>
);
